import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { preventiviApi } from '../api/client';
import RichTextEditor from '../components/RichTextEditor';
import DeliverablesTable from '../components/DeliverablesTable';
import AiAssistant from '../components/AiAssistant';
import { htmlToPlain, plainToSimpleHtml } from '../utils/htmlPlainSync';

const TERMINI_LEGALI_DEFAULT = `
<h2>1. COSTI ANCILLARI E TABELLA EXTRACOSTI</h2>
<h3>1.1 Definizione di costi ancillari</h3>
<p>Si intendono come costi ancillari tutte le lavorazioni, attività o forniture non espressamente incluse nei deliverables principali ma richieste nel corso del progetto. Tali costi includono, a titolo di esempio, servizi accessori come adattamenti, rigenerazioni aggiuntive, versioni extra o ricerche musicali.</p>

<h3>1.2 Tabella indicativa degli extracosti</h3>
<table>
  <tr>
    <td><strong>Rigenerazione AI aggiuntiva</strong><br>Nuova inquadratura o variazione dopo approvazione</td>
    <td>4.000€</td>
  </tr>
  <tr>
    <td><strong>Adattamento formati extra</strong><br>Creazione nuove proporzioni</td>
    <td>500€</td>
  </tr>
  <tr>
    <td><strong>Correzione materiale cliente</strong><br>File errati o non conformi</td>
    <td>300€</td>
  </tr>
  <tr>
    <td><strong>Estensioni o rigenerazioni ambientali</strong><br>A seconda della complessità visiva</td>
    <td>da 1.500€</td>
  </tr>
</table>

<h3>1.3 Condizione di applicabilità</h3>
<p>Eventuali extra costi saranno: comunicati in forma scritta al Cliente (email o documento consuntivo); approvati formalmente prima dell'esecuzione; fatturati separatamente o integrati nel saldo finale.</p>

<h3>1.4 Musica</h3>
<p>AiYR4 non assume responsabilità per musiche, tracce audio o materiali forniti dal Cliente. AiYR4 non è una post-audio house. Qualora venga richiesta ricerca musicale extra, tale servizio sarà quotato separatamente al costo di € 500,00, comprendente la presentazione di due tracce di riferimento non sincronizzate con l'editing. Tutti i costi relativi a musiche, stock, font, plugin o altre licenze di terze parti non espressamente inclusi sono a carico del Cliente, salvo diverso accordo scritto.</p>

<h2>2. PROPRIETÀ INTELLETTUALE, DIRITTI DI UTILIZZO E ETICA DI PRODUZIONE AI</h2>
<h3>2.1 Diritti d'autore e proprietà delle immagini generate</h3>
<p>Tutti i materiali visivi e audiovisivi prodotti da AiYR4 tramite intelligenza artificiale (AI), inclusi ma non limitati a: immagini statiche, frame, key visual, clip video, elementi grafici o strutture visive, restano di proprietà intellettuale di AiYR4, salvo diverso accordo scritto di buyout. L'utilizzo da parte del Cliente è limitato agli usi e alle destinazioni concordati nella fase di approvazione del preventivo o documentazione di kick-off. Eventuali estensioni d'uso (territori, durata, media, archiviazione, NFT, dataset o proiezioni pubbliche) dovranno essere approvate per iscritto da AiYR4.</p>

<h3>2.2 Valutazione qualitativa e diritto di rifiuto</h3>
<p>AiYR4 si riserva il diritto di rifiutare produzioni o destinazioni d'uso che: non rispettino gli standard qualitativi, estetici o tecnici della società; possano compromettere la reputazione del brand; non risultino eticamente compatibili con la visione aziendale; comportino rischi legali o di plagio.</p>

<h3>2.3 Tutela legale e archivio creativo AI</h3>
<p>AiYR4 conserva internamente: tutte le generazioni AI (screenshot, metadata, prompt, step di creazione); documentazione delle reference visive utilizzate; tracciamento delle modifiche e versioni approvate. Tale archivio non sarà divulgato ma potrà essere utilizzato per verifiche legali o richieste di tracciabilità. AiYR4 detiene i diritti legali sulle immagini e sui video generati, con validità giurisdizionale internazionale.</p>

<h2>3. CONDIZIONI DI PAGAMENTO, CONSEGNA E VALIDITÀ CONTRATTUALE</h2>
<h3>3.1 Modalità di pagamento</h3>
<p>Il pagamento della produzione seguirà la seguente struttura:
<ul>
<li>50% alla firma e accettazione del presente preventivo, a titolo di conferma e avvio del progetto;</li>
<li>50% entro la data prevista di delivery finale, salvo eventuali extracosti da consuntivare.</li>
</ul>
Eventuali lavorazioni extra, estensioni, rigenerazioni o modifiche non previste nel preventivo verranno fatturate separatamente, previo accordo scritto, e aggiunte al saldo finale o fatturate a parte secondo tempistiche definite. Le fatture saranno emesse in euro (EUR), oltre IVA se applicabile. La scadenza standard è di 30 giorni dalla data di emissione, salvo diverso accordo scritto tra le parti. In caso di ritardo nei pagamenti, matureranno interessi di mora pari all'8% annuo calcolati pro-rata temporis a partire dalla data di scadenza. AiYR4 si riserva il diritto di sospendere o rinviare le lavorazioni in corso fino alla regolarizzazione dei pagamenti, senza che ciò comporti penali o responsabilità per eventuali slittamenti della timeline di produzione.</p>

<h3>3.2 Cancellation fee</h3>
<p>In caso di cancellazione del progetto dopo la firma del presente documento, si applicheranno le seguenti penali:
<ul>
<li>50% dell'importo totale del progetto fino all'inizio della fase di generazione AI;</li>
<li>100% dell'importo totale oltre tale fase o in caso di cancellazione nella fase finale.</li>
</ul>
Le penali includono le spese di pre-produzione, pianificazione, risorse allocate e oneri organizzativi, e dovranno essere saldate entro 30 giorni dalla comunicazione di cancellazione.</p>

<h3>3.3 Consegna e validità del progetto</h3>
<p>Ogni ritardo da parte del Cliente (materiali errati, feedback oltre i termini, blocchi interni) comporterà un ricalcolo automatico della timeline, senza penali per AiYR4. I file finali verranno archiviati da AiYR4 per un periodo massimo di 365 giorni dalla chiusura del progetto. Trascorso tale termine, non è garantita la disponibilità per recuperi, duplicazioni o re-export.</p>

<h3>3.4 Validità e forza contrattuale del preventivo</h3>
<p>Il presente preventivo ha validità di 30 (trenta) giorni solari dalla data di emissione. Decorso tale termine senza conferma scritta da parte del Cliente, il documento dovrà essere aggiornato e riapprovato. La firma e accettazione del presente documento costituiscono a tutti gli effetti un accordo contrattuale vincolante tra le parti.</p>

<h2>4. FORZA MAGGIORE E LIMITAZIONE DI RESPONSABILITÀ</h2>
<p>AiYR4 non potrà essere ritenuta responsabile per ritardi, inadempienze o impossibilità a rispettare i termini e le condizioni contrattuali qualora tali eventi siano causati da circostanze di forza maggiore (eventi naturali, blackout, interruzioni internet/AI, scioperi, guerre). In tali casi, AiYR4 si impegna a comunicare tempestivamente l'evento al Cliente, proponendo soluzioni alternative. Tali eventi saranno considerati cause esenti da responsabilità contrattuale e non daranno luogo ad alcun risarcimento.</p>
`;

const PreventivoEditor = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [aiAssistantOpen, setAiAssistantOpen] = useState(false);

  // Versioning state
  const [versioneCorrente, setVersioneCorrente] = useState(1);
  const [basataSuCorrente, setBasataSuCorrente] = useState(null);
  const [storicoVersioni, setStoricoVersioni] = useState([]);
  const [showVersioniPanel, setShowVersioniPanel] = useState(false);
  const [creatingVersion, setCreatingVersion] = useState(false);
  const [restoringVersion, setRestoringVersion] = useState(false);

  const [formData, setFormData] = useState({
    numero_preventivo: `PREV-${Date.now()}_V1`,
    cliente_nome: '',
    cliente_piva: '',
    cliente_indirizzo: '',
    fornitore_nome: 'CREA FILM LTD',
    fornitore_vat: 'GB250160647',
    fornitore_indirizzo: '2 Twyford Avenue, W3 9QA London, Regno Unito',
    oggetto: 'Produzione contenuti video mediante Noema (buyout incluso)',
    contenuto_html: TERMINI_LEGALI_DEFAULT,
    termini_modalita: 'richtext',
    totale: 0,
    totale_scontato: 0,
    deadline: '',
    stato: 'bozza',
    note: '',
  });

  const [richtextRemountKey, setRichtextRemountKey] = useState(0);
  const [terminiPlainDraft, setTerminiPlainDraft] = useState('');
  const terminiPlainFocusedRef = useRef(false);
  const terminiPlainDebounceRef = useRef(null);

  useEffect(() => {
    if (formData.termini_modalita !== 'html') return;
    if (terminiPlainFocusedRef.current) return;
    setTerminiPlainDraft(htmlToPlain(formData.contenuto_html));
  }, [formData.contenuto_html, formData.termini_modalita]);

  useEffect(() => {
    return () => {
      if (terminiPlainDebounceRef.current) {
        clearTimeout(terminiPlainDebounceRef.current);
      }
    };
  }, []);

  const [deliverables, setDeliverables] = useState([
    { voce: 'Video prodotto (Noema)', quantita: 6, unita_misura: 'cad', prezzo_unitario: 1500, subtotale: 9000 },
    { voce: 'Video social', quantita: 3, unita_misura: 'cad', prezzo_unitario: 5000, subtotale: 15000 },
    { voce: 'Edit mix extra', quantita: 1, unita_misura: 'cad', prezzo_unitario: 500, subtotale: 500 },
  ]);

  const loadVersioni = useCallback(async () => {
    if (!id) return;
    try {
      const response = await preventiviApi.getVersions(id);
      setStoricoVersioni(response.data.storico || []);
      setBasataSuCorrente(response.data.basata_su_corrente || null);
    } catch (error) {
      console.error('Errore caricamento versioni:', error);
    }
  }, [id]);

  useEffect(() => {
    if (id) {
      loadPreventivo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    // Auto-calculate totals
    const totale = deliverables.reduce((sum, item) => sum + (parseFloat(item.subtotale) || 0), 0);
    setFormData(prev => ({ ...prev, totale }));
  }, [deliverables]);

  const loadPreventivo = async () => {
    try {
      setLoading(true);
      const response = await preventiviApi.getById(id);
      const data = response.data;

      setFormData({
        numero_preventivo: data.numero_preventivo,
        cliente_nome: data.cliente_nome,
        cliente_piva: data.cliente_piva,
        cliente_indirizzo: data.cliente_indirizzo,
        fornitore_nome: data.fornitore_nome,
        fornitore_vat: data.fornitore_vat,
        fornitore_indirizzo: data.fornitore_indirizzo,
        oggetto: data.oggetto,
        contenuto_html: data.contenuto_html || TERMINI_LEGALI_DEFAULT,
        termini_modalita: data.termini_modalita === 'html' ? 'html' : 'richtext',
        totale: data.totale,
        totale_scontato: data.totale_scontato,
        deadline: data.deadline,
        stato: data.stato,
        note: data.note,
      });
      setRichtextRemountKey((k) => k + 1);

      setVersioneCorrente(data.versione_corrente || 1);

      if (data.deliverables && data.deliverables.length > 0) {
        setDeliverables(data.deliverables);
      }

      loadVersioni();
    } catch (error) {
      console.error('Errore caricamento preventivo:', error);
      alert('Errore nel caricamento del preventivo');
    } finally {
      setLoading(false);
    }
  };

  const handleCreateNewVersion = async () => {
    if (!id) return;

    if (!window.confirm(
      `Nuova versione\n\n` +
      `- La V${versioneCorrente} (corrente) viene archiviata nello storico\n` +
      `- Si crea la V${versioneCorrente + 1} con gli stessi dati\n` +
      `- Nessun dato viene perso\n\n` +
      `Vuoi procedere?`
    )) {
      return;
    }

    try {
      setCreatingVersion(true);
      // Prima salva le modifiche correnti
      const data = { ...formData, deliverables };
      await preventiviApi.update(id, data);

      // Poi crea la nuova versione
      const response = await preventiviApi.createNewVersion(id);

      setVersioneCorrente(response.data.versione);
      setFormData(prev => ({
        ...prev,
        numero_preventivo: response.data.numero_preventivo
      }));

      loadVersioni();
    } catch (error) {
      console.error('Errore creazione versione:', error);
      alert('Errore nella creazione della nuova versione');
    } finally {
      setCreatingVersion(false);
    }
  };

  const handleRestoreVersion = async (numeroVersione) => {
    const nextVersion = versioneCorrente + 1;
    if (!window.confirm(
      `Ripristino V${numeroVersione}\n\n` +
      `- La V${versioneCorrente} (corrente) viene archiviata nello storico\n` +
      `- Viene creata la V${nextVersion} con i dati della V${numeroVersione}\n` +
      `- Nessuna versione viene cancellata\n\n` +
      `Vuoi procedere?`
    )) {
      return;
    }

    try {
      setRestoringVersion(true);
      await preventiviApi.restoreVersion(id, numeroVersione);

      // Ricarica tutto il preventivo con i nuovi dati
      await loadPreventivo();
    } catch (error) {
      console.error('Errore ripristino versione:', error);
      alert('Errore nel ripristino della versione');
    } finally {
      setRestoringVersion(false);
    }
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleTerminiModalitaChange = (next) => {
    if (next === 'richtext' && formData.termini_modalita === 'html') {
      if (!window.confirm(
        'Passando all\'editor visuale, il markup HTML può essere normalizzato o modificato da TipTap. Continuare?'
      )) {
        return;
      }
      setRichtextRemountKey((k) => k + 1);
    }
    handleInputChange('termini_modalita', next);
  };

  const handleApplyAiChange = (field, value) => {
    if (field === 'deliverable') {
      const emptyIndex = deliverables.findIndex(d => !d.voce || d.voce.trim() === '');
      if (emptyIndex >= 0) {
        const newDeliverables = [...deliverables];
        newDeliverables[emptyIndex].voce = value;
        setDeliverables(newDeliverables);
      } else {
        setDeliverables([...deliverables, {
          voce: value,
          quantita: 1,
          unita_misura: 'cad',
          prezzo_unitario: 0,
          subtotale: 0
        }]);
      }
    } else if (field === 'prezzo') {
      const noPrice = deliverables.findIndex(d => d.prezzo_unitario === 0);
      if (noPrice >= 0) {
        const newDeliverables = [...deliverables];
        const price = parseFloat(value) || 0;
        newDeliverables[noPrice].prezzo_unitario = price;
        newDeliverables[noPrice].subtotale = newDeliverables[noPrice].quantita * price;
        setDeliverables(newDeliverables);
      }
    } else {
      handleInputChange(field, value);
    }
  };

  const handleSave = async () => {
    if (!formData.cliente_nome) {
      alert('Inserisci il nome del cliente');
      return;
    }

    try {
      setSaving(true);
      const data = {
        ...formData,
        deliverables,
      };

      if (id) {
        await preventiviApi.update(id, data);
      } else {
        const response = await preventiviApi.create(data);
        navigate(`/preventivi/${response.data.id}/edit`);
        return;
      }
    } catch (error) {
      console.error('Errore salvataggio:', error);
      alert('Errore durante il salvataggio');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="max-w-6xl mx-auto px-6 pb-20">
      {/* Top Bar - Fixed at top of content area */}
      <div className="sticky top-0 z-20 -mx-6 px-6 py-4 bg-gray-50/95 dark:bg-[#0f0f0f]/95 backdrop-blur-md border-b border-gray-200/50 dark:border-gray-800/50">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate('/preventivi')}
              className="p-2 text-gray-400 hover:text-black dark:hover:text-white transition-colors rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800"
              title="Torna ai preventivi"
            >
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
            </button>
            <h1 className="text-lg font-semibold tracking-tight text-black dark:text-white">
              {id ? 'Modifica Preventivo' : 'Nuovo Preventivo'}
            </h1>
          </div>

          <div className="flex gap-2 items-center">
            {/* Versioni dropdown */}
            {id && (
              <div className="flex items-center gap-1.5">
                {/* Tabs per le versioni */}
                <div className="flex items-center bg-gray-100 dark:bg-gray-800 rounded-lg p-0.5">
                  {/* Versione corrente */}
                  <span className="px-3 py-1.5 bg-black dark:bg-white text-white dark:text-black text-xs font-bold rounded-md" title={basataSuCorrente ? `Partita da V${basataSuCorrente}` : `Versione corrente`}>
                    V{versioneCorrente}
                    {basataSuCorrente && (
                      <span className="ml-1 opacity-70 font-normal">da V{basataSuCorrente}</span>
                    )}
                  </span>

                  {/* Toggle storico */}
                  <button
                    onClick={() => setShowVersioniPanel(!showVersioniPanel)}
                    className={`px-3 py-1.5 text-xs font-medium rounded-md transition-all ${
                      showVersioniPanel 
                        ? 'bg-gray-200 dark:bg-gray-700 text-black dark:text-white' 
                        : 'text-gray-500 hover:text-black dark:hover:text-white'
                    }`}
                  >
                    Storico ({storicoVersioni.length})
                  </button>
                </div>

                {/* Nuova Versione */}
                <button
                  onClick={handleCreateNewVersion}
                  disabled={creatingVersion}
                  className="px-3 py-1.5 text-xs font-medium text-green-600 dark:text-green-400 bg-green-50 dark:bg-green-900/30 hover:bg-green-100 dark:hover:bg-green-900/50 rounded-lg transition-all disabled:opacity-50"
                  title="Archivia la versione corrente e crea una nuova"
                >
                  {creatingVersion ? '...' : '+ Nuova Versione'}
                </button>
              </div>
            )}

            {/* AI Assistant */}
            <button
              onClick={() => setAiAssistantOpen(true)}
              className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-gray-500 hover:text-black dark:text-gray-400 dark:hover:text-white bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 rounded-lg transition-all"
            >
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
              AI
            </button>

            {/* Salva */}
            <button
              onClick={handleSave}
              disabled={saving}
              className="px-5 py-2 bg-black text-white dark:bg-white dark:text-black text-xs font-semibold uppercase tracking-wider rounded-lg hover:opacity-90 transition-all disabled:opacity-50"
            >
              {saving ? 'Salvataggio...' : id ? 'Salva' : 'Crea Preventivo'}
            </button>
          </div>
        </div>
      </div>

      {/* Pannello Storico Versioni - Timeline completa */}
      {showVersioniPanel && (
        <div className="mt-4 mb-6 bg-white dark:bg-[#1a1a1a] rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden animate-fade-in">
          <div className="px-5 py-3 border-b border-gray-100 dark:border-gray-800 flex justify-between items-center">
            <div>
              <h3 className="text-sm font-semibold text-gray-700 dark:text-gray-300">
                Timeline Versioni
              </h3>
              <p className="text-[11px] text-gray-400 mt-0.5">
                Tutte le versioni sono archiviate e non vengono mai cancellate.
              </p>
            </div>
            <button
              onClick={() => setShowVersioniPanel(false)}
              className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 text-lg leading-none p-1"
            >
              &times;
            </button>
          </div>

          <div className="divide-y divide-gray-100 dark:divide-gray-800">
            {/* Versione corrente - sempre in cima */}
            <div className="flex items-center justify-between px-5 py-3 bg-blue-50/50 dark:bg-blue-900/10">
              <div className="flex items-center gap-3">
                <span className="px-2.5 py-1 bg-black dark:bg-white text-white dark:text-black text-xs font-bold rounded">
                  V{versioneCorrente}
                </span>
                <div>
                  <div className="flex items-center gap-2">
                    <p className="text-sm font-semibold text-black dark:text-white">
                      {formData.oggetto || 'Senza titolo'}
                    </p>
                    <span className="px-1.5 py-0.5 bg-green-100 dark:bg-green-900/40 text-green-700 dark:text-green-300 text-[10px] font-semibold rounded uppercase">
                      corrente
                    </span>
                  </div>
                  <p className="text-[11px] text-gray-400 mt-0.5">
                    {formData.cliente_nome || '—'}
                    {' — '}
                    € {(formData.totale_scontato || formData.totale || 0).toLocaleString('it-IT')}
                    {basataSuCorrente && (
                      <span className="ml-2 text-blue-500 dark:text-blue-400 font-medium">
                        partita da V{basataSuCorrente}
                      </span>
                    )}
                  </p>
                </div>
              </div>
              <span className="text-[10px] text-gray-300 dark:text-gray-600 uppercase tracking-wider">
                in modifica
              </span>
            </div>

            {/* Versioni archiviate */}
            {storicoVersioni.length === 0 ? (
              <div className="p-5 text-sm text-gray-400 text-center">
                Nessuna versione precedente. Usa "Nuova Versione" per archiviare la corrente e creare una nuova.
              </div>
            ) : (
              storicoVersioni.map((v) => (
                <div
                  key={v.id}
                  className="flex items-center justify-between px-5 py-3 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors"
                >
                  <div className="flex items-center gap-3">
                    <span className="px-2.5 py-1 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 text-xs font-bold rounded">
                      V{v.numero_versione}
                    </span>
                    <div>
                      <p className="text-sm font-medium text-gray-700 dark:text-gray-200">
                        {v.oggetto || 'Senza titolo'}
                      </p>
                      <p className="text-[11px] text-gray-400 mt-0.5">
                        {new Date(v.data_versione).toLocaleDateString('it-IT', {
                          day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit'
                        })}
                        {' — '}
                        {v.cliente_nome}
                        {' — '}
                        € {(v.totale_scontato || v.totale || 0).toLocaleString('it-IT')}
                        {v.basata_su && (
                          <span className="ml-2 text-blue-500 dark:text-blue-400 font-medium">
                            partita da V{v.basata_su}
                          </span>
                        )}
                      </p>
                    </div>
                  </div>
                  <button
                    onClick={() => handleRestoreVersion(v.numero_versione)}
                    disabled={restoringVersion}
                    className="px-3 py-1.5 text-xs font-medium bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 rounded-lg hover:bg-blue-50 hover:text-blue-600 dark:hover:bg-blue-900/30 dark:hover:text-blue-300 transition-colors disabled:opacity-50 whitespace-nowrap"
                    title={`Crea V${versioneCorrente + 1} partendo dai dati della V${v.numero_versione}. La V${versioneCorrente} viene archiviata.`}
                  >
                    {restoringVersion ? '...' : 'Usa come base'}
                  </button>
                </div>
              ))
            )}
          </div>
        </div>
      )}

      <div className="grid grid-cols-12 gap-8 mt-6">
        {/* Sidebar Settings */}
        <div className="col-span-12 lg:col-span-4 space-y-6">
          <div className="bg-white dark:bg-[#1a1a1a] p-6 rounded-xl border border-gray-100 dark:border-gray-800">
            <h3 className="text-[10px] uppercase tracking-[0.2em] text-gray-400 mb-5">Info Progetto</h3>

            <div className="space-y-5">
              <div>
                <label className="block text-[10px] font-medium text-gray-400 mb-1.5 uppercase tracking-[0.1em]">
                  Numero
                </label>
                <input
                  type="text"
                  value={formData.numero_preventivo}
                  onChange={(e) => handleInputChange('numero_preventivo', e.target.value)}
                  className="input-minimal text-sm"
                />
              </div>

              <div>
                <label className="block text-[10px] font-medium text-gray-400 mb-1.5 uppercase tracking-[0.1em]">
                  Stato
                </label>
                <select
                  value={formData.stato}
                  onChange={(e) => handleInputChange('stato', e.target.value)}
                  className="input-minimal uppercase text-sm"
                >
                  <option value="bozza">Bozza</option>
                  <option value="inviato">Inviato</option>
                  <option value="approvato">Approvato</option>
                  <option value="rifiutato">Rifiutato</option>
                </select>
              </div>

              <div>
                <label className="block text-[10px] font-medium text-gray-400 mb-1.5 uppercase tracking-[0.1em]">
                  Deadline
                </label>
                <input
                  type="date"
                  value={formData.deadline}
                  onChange={(e) => handleInputChange('deadline', e.target.value)}
                  className="input-minimal text-sm"
                />
              </div>
            </div>
          </div>

          <div className="bg-white dark:bg-[#1a1a1a] p-6 rounded-xl border border-gray-100 dark:border-gray-800">
            <h3 className="text-[10px] uppercase tracking-[0.2em] text-gray-400 mb-5">Cliente</h3>
            <div className="space-y-4">
              <div>
                <input
                  type="text"
                  value={formData.cliente_nome}
                  onChange={(e) => handleInputChange('cliente_nome', e.target.value)}
                  className="input-minimal text-lg font-medium w-full"
                  placeholder="Nome Cliente..."
                />
              </div>
              <div>
                <input
                  type="text"
                  value={formData.cliente_piva}
                  onChange={(e) => handleInputChange('cliente_piva', e.target.value)}
                  className="input-minimal text-sm w-full"
                  placeholder="P.IVA / C.F."
                />
              </div>
              <div>
                <textarea
                  value={formData.cliente_indirizzo}
                  onChange={(e) => handleInputChange('cliente_indirizzo', e.target.value)}
                  className="input-minimal text-sm w-full resize-none"
                  rows="2"
                  placeholder="Indirizzo completo..."
                />
              </div>
            </div>
          </div>
        </div>

        {/* Main Editor Area */}
        <div className="col-span-12 lg:col-span-8 space-y-8">

          {/* Oggetto */}
          <section>
            <h3 className="text-[10px] uppercase tracking-[0.2em] text-gray-400 mb-3">Oggetto</h3>
            <div className="bg-white dark:bg-[#1a1a1a] p-6 rounded-xl border border-gray-100 dark:border-gray-800">
              <textarea
                value={formData.oggetto}
                onChange={(e) => handleInputChange('oggetto', e.target.value)}
                rows="3"
                className="w-full border-none resize-none focus:outline-none text-base font-light leading-relaxed text-black dark:text-white placeholder-gray-400 dark:placeholder-gray-500 bg-transparent"
                placeholder="Descrivi l'oggetto del preventivo..."
              />
            </div>
          </section>

          {/* Deliverables */}
          <section>
            <h3 className="text-[10px] uppercase tracking-[0.2em] text-gray-400 mb-3">Deliverables & Costi</h3>
            <div className="bg-white dark:bg-[#1a1a1a] p-6 rounded-xl border border-gray-100 dark:border-gray-800">
              <DeliverablesTable deliverables={deliverables} onChange={setDeliverables} />

              <div className="mt-6 pt-6 border-t border-gray-100 dark:border-gray-800 flex justify-end">
                <div className="w-1/2 space-y-3">
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-500">Totale</span>
                    <span className="text-lg font-semibold text-black dark:text-white">€ {formData.totale.toFixed(2)}</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-500">Scontato</span>
                    <input
                      type="number"
                      value={formData.totale_scontato}
                      onChange={(e) => handleInputChange('totale_scontato', parseFloat(e.target.value))}
                      className="input-minimal text-right w-32 text-lg font-semibold"
                      placeholder="0.00"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Termini contrattuali: editor visuale o HTML grezzo */}
          <section>
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-3">
              <h3 className="text-[10px] uppercase tracking-[0.2em] text-gray-400">Termini contrattuali</h3>
              <div className="flex rounded-lg border border-gray-200 dark:border-gray-700 p-0.5 bg-gray-100 dark:bg-gray-800/80 shrink-0">
                <button
                  type="button"
                  onClick={() => handleTerminiModalitaChange('richtext')}
                  className={`px-3 py-1.5 text-[10px] uppercase tracking-wider rounded-md transition-colors ${
                    formData.termini_modalita !== 'html'
                      ? 'bg-black dark:bg-white text-white dark:text-black font-semibold'
                      : 'text-gray-500 hover:text-black dark:hover:text-white'
                  }`}
                >
                  Editor
                </button>
                <button
                  type="button"
                  onClick={() => handleTerminiModalitaChange('html')}
                  className={`px-3 py-1.5 text-[10px] uppercase tracking-wider rounded-md transition-colors ${
                    formData.termini_modalita === 'html'
                      ? 'bg-black dark:bg-white text-white dark:text-black font-semibold'
                      : 'text-gray-500 hover:text-black dark:hover:text-white'
                  }`}
                >
                  HTML
                </button>
              </div>
            </div>
            {formData.termini_modalita === 'html' ? (
              <div className="space-y-3">
                <p className="text-[11px] text-gray-500 dark:text-gray-400 leading-relaxed max-w-3xl">
                  Il <strong className="font-medium text-gray-600 dark:text-gray-300">testo semplice</strong> si aggiorna quando modifichi l’HTML. Se modifichi il testo semplice, il contenuto diventa paragrafi e a capo (<code className="text-[10px] bg-gray-100 dark:bg-gray-800 px-1 rounded">&lt;p&gt;</code>,{' '}
                  <code className="text-[10px] bg-gray-100 dark:bg-gray-800 px-1 rounded">&lt;br&gt;</code>
                  ): tabelle ed elenchi strutturati vanno persi — usali solo nell’HTML.
                </p>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 bg-white dark:bg-[#1a1a1a] rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden">
                  <div className="flex flex-col min-h-[min(70vh,520px)] border-b lg:border-b-0 lg:border-r border-gray-200 dark:border-gray-700">
                    <div className="px-3 py-2 text-[10px] uppercase tracking-wider text-gray-400 border-b border-gray-100 dark:border-gray-800 shrink-0">
                      HTML
                    </div>
                    <textarea
                      value={formData.contenuto_html}
                      onChange={(e) => handleInputChange('contenuto_html', e.target.value)}
                      onFocus={() => {
                        terminiPlainFocusedRef.current = false;
                      }}
                      spellCheck={false}
                      className="flex-1 w-full min-h-[280px] p-4 font-mono text-xs leading-relaxed text-black dark:text-white bg-transparent border-none focus:outline-none focus:ring-0 resize-y"
                    />
                  </div>
                  <div className="flex flex-col min-h-[min(70vh,520px)]">
                    <div className="px-3 py-2 text-[10px] uppercase tracking-wider text-gray-400 border-b border-gray-100 dark:border-gray-800 shrink-0">
                      Testo semplice
                    </div>
                    <textarea
                      value={terminiPlainDraft}
                      onChange={(e) => {
                        const v = e.target.value;
                        setTerminiPlainDraft(v);
                        if (terminiPlainDebounceRef.current) {
                          clearTimeout(terminiPlainDebounceRef.current);
                        }
                        terminiPlainDebounceRef.current = setTimeout(() => {
                          terminiPlainDebounceRef.current = null;
                          handleInputChange('contenuto_html', plainToSimpleHtml(v));
                        }, 200);
                      }}
                      onFocus={() => {
                        terminiPlainFocusedRef.current = true;
                      }}
                      onBlur={(e) => {
                        if (terminiPlainDebounceRef.current) {
                          clearTimeout(terminiPlainDebounceRef.current);
                          terminiPlainDebounceRef.current = null;
                        }
                        handleInputChange('contenuto_html', plainToSimpleHtml(e.target.value));
                        terminiPlainFocusedRef.current = false;
                      }}
                      spellCheck={true}
                      className="flex-1 w-full min-h-[280px] p-4 text-sm leading-relaxed text-black dark:text-white bg-transparent border-none focus:outline-none focus:ring-0 resize-y"
                      placeholder="Testo senza tag, sincronizzato con l’HTML…"
                    />
                  </div>
                </div>
              </div>
            ) : (
              <RichTextEditor
                key={`rte-${id || 'new'}-${richtextRemountKey}`}
                content={formData.contenuto_html}
                onChange={(html) => handleInputChange('contenuto_html', html)}
              />
            )}
          </section>

          {/* Note Interne */}
          <section className="opacity-60 hover:opacity-100 transition-opacity">
            <h3 className="text-[10px] uppercase tracking-[0.2em] text-gray-400 mb-3">Note Private</h3>
            <div className="bg-white dark:bg-[#1a1a1a] p-5 rounded-xl border border-gray-100 dark:border-gray-800 border-l-4 border-l-gray-300 dark:border-l-gray-600">
              <textarea
                value={formData.note}
                onChange={(e) => handleInputChange('note', e.target.value)}
                rows="2"
                className="w-full border-none resize-none focus:outline-none text-sm text-gray-600 dark:text-gray-400 bg-transparent"
                placeholder="Appunti interni (non visibili al cliente)..."
              />
            </div>
          </section>

        </div>
      </div>

      {/* AI Assistant Panel */}
      <AiAssistant
        isOpen={aiAssistantOpen}
        onClose={() => setAiAssistantOpen(false)}
        context={{
          cliente_nome: formData.cliente_nome,
          oggetto: formData.oggetto,
          totale: formData.totale,
          deliverables: deliverables
        }}
        onApplyChange={handleApplyAiChange}
      />
    </div>
  );
};

export default PreventivoEditor;
